'use strict';

var _ = require('lodash');

//helper abstract factory for KPI Ribbon Aggregation

var AbstractRomKpiRibbonAggregationFactory = function AbstractRomKpiRibbonAggregationFactory(AbstractDataAggregationFactory, ConfigurationService) {
  function AbstractRomKpiRibbonAggregation() {
    AbstractDataAggregationFactory.apply(this, arguments);
  }
  AbstractRomKpiRibbonAggregation.prototype = Object.create(AbstractDataAggregationFactory.prototype);
  AbstractRomKpiRibbonAggregation.constructor = AbstractRomKpiRibbonAggregation;
  AbstractRomKpiRibbonAggregation.prototype.accumulate = function (item, metricsKeys, accumulated) {
    accumulated = accumulated || {};
    accumulated.maxRevenue = _.add(this.getMetricValue(item.maxRevenue, metricsKeys), accumulated.maxRevenue);
    accumulated.maxSale = _.add(this.getMetricValue(item.maxSale, metricsKeys), accumulated.maxSale);
    accumulated.actualRevenue = _.add(this.getMetricValue(item.actualRevenue, metricsKeys), accumulated.actualRevenue);
    accumulated.actualSale = _.add(this.getMetricValue(item.actualSale, metricsKeys), accumulated.actualSale);
    accumulated.minRevenue = _.add(this.getMetricValue(item.minRevenue, metricsKeys), accumulated.minRevenue);
    accumulated.fcDemand = _.add(this.getMetricValue(item.fcDemand, metricsKeys), accumulated.fcDemand);
    accumulated.maxRecapture = _.add(this.getMetricValue(item.maxRecapture, metricsKeys), accumulated.maxRecapture);
    accumulated.maxSpill = _.add(this.getMetricValue(item.maxSpill, metricsKeys), accumulated.maxSpill);
    accumulated.actualRecapture = _.add(this.getMetricValue(item.actualRecapture, metricsKeys), accumulated.actualRecapture);
    accumulated.actualSpill = _.add(this.getMetricValue(item.actualSpill, metricsKeys), accumulated.actualSpill);
    accumulated.maxRecaptureRevenue = _.add(this.getMetricValue(item.maxRecaptureRevenue, metricsKeys), accumulated.maxRecaptureRevenue);
    accumulated.maxSpillRevenue = _.add(this.getMetricValue(item.maxSpillRevenue, metricsKeys), accumulated.maxSpillRevenue);
    accumulated.actualRecaptureRevenue = _.add(this.getMetricValue(item.actualRecaptureRevenue, metricsKeys), accumulated.actualRecaptureRevenue);
    accumulated.actualSpillRevenue = _.add(this.getMetricValue(item.actualSpillRevenue, metricsKeys), accumulated.actualSpillRevenue);
    accumulated.optimalOpenPct = _.add(this.getCombinedMetricValue(item.maxOpenPct, item.fcDemand, metricsKeys), accumulated.optimalOpenPct);
    accumulated.actualOpenPct = _.add(this.getCombinedMetricValue(item.actualOpenPct, item.fcDemand, metricsKeys), accumulated.actualOpenPct);
    accumulated.revenueGap = _.add(this.getMetricValue(item.revenueGap, metricsKeys), accumulated.revenueGap);
    accumulated.spillRevenueGap = _.add(this.getMetricValue(item.spillRevenueGap, metricsKeys), accumulated.spillRevenueGap);
    accumulated.recaptureRevenueGap = _.add(this.getMetricValue(item.recaptureRevenueGap, metricsKeys), accumulated.recaptureRevenueGap);
    accumulated.saleGap = _.add(this.getMetricValue(item.saleGap, metricsKeys), accumulated.saleGap);
    accumulated.spillGap = _.add(this.getMetricValue(item.spillGap, metricsKeys), accumulated.spillGap);
    accumulated.recapGap = _.add(this.getMetricValue(item.recapGap, metricsKeys), accumulated.recapGap);
    return accumulated;
  };
  AbstractRomKpiRibbonAggregation.prototype.iterate = function (data, metricsKeys, grouped) {
    grouped = grouped || {};
    for (var index = 0, keys = Object.keys(data), dataLength = keys.length; index < dataLength; index++) {
      var item = data[keys[index]];
      this.accumulate(item, metricsKeys, grouped);
    }
    return grouped;
  };
  AbstractRomKpiRibbonAggregation.prototype.group = function (data, metricsKeys, grouped) {
    grouped = grouped || {};
    for (var index = 0, keys = Object.keys(data), dataLength = keys.length; index < dataLength; index++) {
      var item = data[keys[index]];
      grouped[item.optGroupWeek] = grouped[item.optGroupWeek] || {};
      this.accumulate(item, metricsKeys, grouped[item.optGroupWeek]);
    }
    return grouped;
  };
  AbstractRomKpiRibbonAggregation.prototype.calcGap = function (aggregated, isReference) {
    // map of keys for regular fields or with LastYear
    var keysLY = {
      suffix: 'LY',
      revOpp: 'revOpp',
      averageFareGap: 'averageFareGap',
      openPercent: 'openPercent',
      recaptureRateGap: 'recaptureRateGap',
      recaptureSpillFareRatioGap: 'recaptureSpillFareRatioGap'
    };
    var referenceWeeks = ConfigurationService.getROMMaxReferenceWeeks();
    var revOpp = Math.min((aggregated.actualRevenue - Math.min(aggregated.maxRevenue, aggregated.actualRevenue, aggregated.minRevenue)) * 100 / Math.abs(aggregated.maxRevenue - aggregated.minRevenue), 200);
    aggregated.averageFareOptimal = aggregated.maxRevenue / aggregated.maxSale;
    aggregated.averageFareActual = aggregated.actualRevenue / aggregated.actualSale;
    var averageFareGap = aggregated.averageFareOptimal - aggregated.averageFareActual;
    aggregated.openPercentOptimal = aggregated.optimalOpenPct / aggregated.fcDemand * 100;
    aggregated.openPercentActual = aggregated.actualOpenPct / aggregated.fcDemand * 100;
    var openPercent = aggregated.openPercentOptimal - aggregated.openPercentActual;
    aggregated.recaptureRateOptimal = aggregated.maxRecapture / aggregated.maxSpill * 100;
    aggregated.recaptureRateActual = aggregated.actualRecapture / aggregated.actualSpill * 100;
    var recaptureRateGap = aggregated.recaptureRateOptimal - aggregated.recaptureRateActual;
    aggregated.recaptureSpillFareRatioOptimal = aggregated.maxRecaptureRevenue / aggregated.maxRecapture / (aggregated.maxSpillRevenue / aggregated.maxSpill);
    aggregated.recaptureSpillFareRatioActual = aggregated.actualRecaptureRevenue / aggregated.actualRecapture / (aggregated.actualSpillRevenue / aggregated.actualSpill);
    var recaptureSpillFareRatioGap = aggregated.recaptureSpillFareRatioOptimal - aggregated.recaptureSpillFareRatioActual;

    // if reference data, key should be like: 'keyName' + 'LY'
    if (isReference) {
      aggregated[keysLY.revOpp + keysLY.suffix] = revOpp;
      aggregated[keysLY.averageFareGap + keysLY.suffix] = averageFareGap;
      aggregated[keysLY.openPercent + keysLY.suffix] = openPercent;
      aggregated[keysLY.recaptureRateGap + keysLY.suffix] = recaptureRateGap;
      aggregated[keysLY.recaptureSpillFareRatioGap + keysLY.suffix] = recaptureSpillFareRatioGap;
      aggregated.revenueGapLY = aggregated.revenueGap / referenceWeeks;
      aggregated.spillRevenueGapLY = aggregated.spillRevenueGap / referenceWeeks;
      aggregated.recaptureRevenueGapLY = aggregated.recaptureRevenueGap / referenceWeeks;
      aggregated.saleGapLY = aggregated.saleGap / referenceWeeks;
      aggregated.spillGapLY = aggregated.spillGap / referenceWeeks;
      aggregated.recapGapLY = aggregated.recapGap / referenceWeeks;
    } else {
      aggregated[keysLY.revOpp] = revOpp;
      aggregated[keysLY.averageFareGap] = averageFareGap;
      aggregated[keysLY.openPercent] = openPercent;
      aggregated[keysLY.recaptureRateGap] = recaptureRateGap;
      aggregated[keysLY.recaptureSpillFareRatioGap] = recaptureSpillFareRatioGap;
    }

    // setting needed fields to undefined for regular and referenced data
    var fields = {
      regular: ['optimalOpenPct', 'actualOpenPct', 'maxRecapture', 'maxSpill', 'actualRecapture', 'actualSpill', 'maxRecaptureRevenue', 'maxSpillRevenue', 'actualRecaptureRevenue', 'actualSpillRevenue', 'minRevenue'],
      reference: ['revenueGap', 'saleGap', 'spillRevenueGap', 'recaptureRevenueGap', 'spillGap', 'recapGap', 'maxRevenue', 'maxSale', 'actualRevenue', 'actualSale', 'fcDemand', 'averageFareOptimal', 'averageFareActual', 'openPercentOptimal', 'openPercentActual', 'recaptureRateOptimal', 'recaptureRateActual', 'recaptureSpillFareRatioOptimal', 'recaptureSpillFareRatioActual'],
      setUndefined: function setUndefined(obj) {
        var keys = isReference ? this.regular.concat(this.reference) : this.regular;
        keys.forEach(function (key) {
          obj[key] = undefined;
        });
        return obj;
      }
    };
    return fields.setUndefined(aggregated);
  };
  return AbstractRomKpiRibbonAggregation;
};
AbstractRomKpiRibbonAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory', 'ConfigurationService'];
module.exports = AbstractRomKpiRibbonAggregationFactory;